import { Component, OnInit, ViewChild } from '@angular/core';
import { Routes, ActivatedRoute, Router } from '@angular/router';
import { IHeaderTitle } from 'app/shared/models/header-title';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { User } from 'app/shared/models/User';
import { AlertMessageComponent } from 'app/shared/components/alert-message/alert-message.component';
import { Location } from '@angular/common';
import { AuditDetailsModel } from 'app/audit/models/audit-details-model';
import { AuditService } from 'app/audit/services/audit.service';
import { AuditTypeModel } from 'app/audit/models/audit-type.model';

@Component({
    templateUrl: './audit-details.component.html',
    styleUrls: ['./audit-details.component.css']
})
export class AuditDetailsComponent implements OnInit {
    auditDetailsModel: AuditDetailsModel;
    errors: string[];
    headerTitle: IHeaderTitle;
    submitAttempt = false;
    @ViewChild(AlertMessageComponent, { static: false }) alertMessage: AlertMessageComponent;
    redirectRoutes: Routes;
    auditDetailsFormGroup: FormGroup;
    isEditMode = false;
    userDetails: User;
    auditId: string;
    auditTypes: AuditTypeModel[];

    constructor(
        private auditService: AuditService,
        private activatedRoute: ActivatedRoute,
        private fb: FormBuilder,
		private location: Location,
        private router: Router
    ) { }

    ngOnInit() {
        this.load();
    }

    load(): void {
        this.getAuditTypes();
        this.auditId = this.activatedRoute.snapshot.params['id'];
        this.auditService.get(this.auditId).subscribe(auditInfo => {
            this.auditDetailsModel = auditInfo;
            this.initializeForm(auditInfo);
            this.headerTitle = {
                title: auditInfo.name,
                breadcrumbs: [{ title: 'Audits', url: ['/audit'] }]
            };
        });
    }

    getAuditTypes(): void {
        this.auditService.getAuditTypes().subscribe(result => {
            this.auditTypes = result;
        });
    }

    initializeForm(model: AuditDetailsModel): void {
        this.auditDetailsFormGroup = this.fb.group(
            {
                id: [this.auditId],
                name: [model.name, Validators.required],
                description: [model.description],
                isActive: [model.isActive]
            }
        );
    }

    toggleEditMode(): void {
        this.isEditMode = !this.isEditMode;
    }

    updateAudit(): void {
        this.submitAttempt = true;
        if (this.auditDetailsFormGroup.valid) {
            const formValue = this.auditDetailsFormGroup.value;
            this.auditService.update(formValue).subscribe(
                response => {
                    this.alertMessage.showMessage();
                },
                error => {
                    this.errors = error.errorList;
                }
            );
        }
    }

    successClicked($event: any): void {
        this.router.navigate(['./audit']);
    }

    onHide($event: any): void { }

    onBack($event: any): void {
        this.location.back();
    }
}
